export class AllEventsSetting {
  public data: any;
  public message: string;
}



// WEBPACK FOOTER //
// /app/src/app/models/all-events-setting.ts